import React, { Component } from 'react';
import { Col, Row } from 'antd';
import Big from 'big.js';
import Pie from '@comm/charts/Pie2/Index';
import Rank from '@comm/charts/Rank/Index';
import { queryUnbusinessByType, queryUnbusinessRecord } from '@api/incubator/finance';
import util from '@util/index';
import TableDetail from './TableDetail';
import '../analyze.less';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: {},
      pieData2: [],
      legendData: [],
      recordData: {
        list: [],
        pagination: {},
      },
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.condition = {};
    this.getUnbusinessByType();
    this.getUnbusinessRecord();
  }

  componentWillReceiveProps(nextProps) {
    if (
      Object.keys(nextProps.condition || {}).some(
        key => nextProps.condition[key] !== this.condition[key],
      )
    ) {
      this.condition = nextProps.condition;
      this.getUnbusinessByType();
      this.getUnbusinessRecord();
    }
  }

  findTypeName = record => {
    let typeName = '';
    const { incomeType, expendType } = this.props;
    const type = record.target === 0 ? expendType : incomeType;
    type.forEach(item => {
      if (record.type === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  getUnbusinessByType = () => {
    let sum = new Big(0);
    queryUnbusinessByType({
      incubatorUuid: this.props.params.uuid,
      target: 1,
      ...this.condition,
    }).then(res => {
      if (res.statusCode === 200) {
        const pieData2 = [];
        const legendData = [];
        const selected = {};
        res.data.forEach((item, index) => {
          const typeName = this.findTypeName(item) || item.type;
          sum = sum.plus(new Big(item.price || 0));
          selected[typeName] = index < 10;
          pieData2.push({
            name: typeName,
            value: item.price,
          });
          legendData.push(typeName);
        });
        this.setState({
          selected,
          pieData2,
          legendData,
          sum: util.numberFormat(sum),
        });
      }
    });
  };

  getUnbusinessRecord = () => {
    const pageSize = 10;
    queryUnbusinessRecord({
      incubatorUuid: this.props.params.uuid,
      target: 1,
      limit: pageSize,
      start: this.current || 1,
      ...this.condition,
    }).then(res => {
      res.data.forEach(item => {
        item.typeName = this.findTypeName(item);
      });
      this.setState({
        recordData: {
          list: res.data,
          pagination: {
            total: res.totalSize,
            pageSize,
            current: this.current,
          },
        },
      });
    });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.current = pagination.current;
    this.getUnbusinessRecord();
  };

  render() {
    const { recordData, sum, pieData2, selected, legendData } = this.state;
    const pieData3 = {
      title: '收入类型统计',
      selected,
      legendData,
      seriesData: pieData2,
    };
    return (
      <div className="analyze">
        <Row type="flex" justify="space-between">
          <Col span={15}>
            <Pie
              data={pieData3}
              title="收入占比图"
              inData={{ title: '非合同款收入', num: sum, unit: '元' }}
            />
          </Col>
          <Col span={8}>
            <Rank data={pieData2} title="收入类型排名" />
          </Col>
        </Row>
        <TableDetail data={recordData} handleChange={this.handleTableChange} />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/analyze/notContract/TabChart.js